module.exports = __webpack_public_path__ + "assets/img/B-585998ae.jpg";